export class TransaccionesRecurrentes {
  static get PROPIEDADES_EXPORTAR() {
    return [
      {value: "IdSec", label: "Id"},
      {value: "TipoComprobanteDesc", label: "Tipo de Comprobante"},
      {value: "RNCComprador", label: "Documento"},
      {value: "RazonSocialComprador", label: "Razón Social"},
      {value: "ProgramacionDesc", label: "Programación"},
      {value: "EstatusDesc", label: "Estatus"},
      {value: "MontoTotal", label: "Monto Total"},
      { value: "FechaCreacion", label: "Fecha Creación"},
      { value: "CrearUsuario", label: "Usuario Creación"},
      {value: "FechaActualizacion", label: "Fecha Actualización"},
      {value: "ActualizarUsuario", label: "Usuario Actualización"}
    ]
  }
}